import React, { createContext, useContext, useState } from 'react';

export const languages = [
    { code: 'en', label: 'English', nativeLabel: 'English', flag: '🇬🇧', dir: 'ltr' },
    { code: 'hi', label: 'Hindi', nativeLabel: 'हिन्दी', flag: '🇮🇳', dir: 'ltr' },
    { code: 'mr', label: 'Marathi', nativeLabel: 'मराठी', flag: '🇮🇳', dir: 'ltr' },
    { code: 'ar', label: 'Arabic', nativeLabel: 'العربية', flag: '🇸🇦', dir: 'rtl' },
];

export const translations = {
    en: {
        // Navigation / Sidebar
        dashboard: 'Dashboard',
        students: 'Students',
        teachers: 'Teachers',
        classes: 'Classes',
        timetable: 'Timetable',
        attendance: 'Attendance',
        examinations: 'Examinations',
        fees: 'Fees',
        notices: 'Notices',
        transport: 'Transport',
        settings: 'Settings',
        lms: 'LMS',
        myClasses: 'My Classes',
        assignments: 'Assignments',
        exams: 'Exams',
        events: 'Events',
        leaveRequest: 'Leave Request',
        logout: 'Logout',
        signOut: 'Sign Out',
        feeCollection: 'Fee Collection',
        reports: 'Reports',
        financeConsole: 'Finance Console',
        financeConsoleSub: 'Real-time institutional financial overview and fee tracking',
        teacherDashboard: 'Teacher Dashboard',
        teacherDashboardSub: 'Welcome back, Dr. Sarah Johnson',
        viewAll: 'View All',
        viewAllSubmissions: 'View All Submissions',
        recentStudentTask: 'Recent Student Task',
        upcomingSchedule: 'Upcoming Schedule',
        classPerformanceTrends: 'Class Performance Trends',
        classAttendance: 'Class Attendance',
        recentCollections: 'Recent Collections',
        totalLiquidity: 'Total Liquidity',
        collectionRate: 'Collection Rate',
        initiateSettlement: 'Initiate Settlement',
        recentActivity: 'Recent Activity',
        quickActions: 'Quick Actions',
        financialAnalytics: 'Financial Analytics',
        systemHealth: 'System Health',
        present: 'Present',
        absent: 'Absent',

        // Header
        adminDashboard: 'Admin Dashboard',
        adminDashboardSub: 'System overview and school performance analytics',
        academicSession: 'Academic Session 2025-26',
        language: 'Language',

        // Login
        welcomeBack: 'Welcome back',
        loginSubtitle: 'Log in to your NerdOS account',
        email: 'Email',
        password: 'Password',
        forgotPassword: 'Forgot password?',
        logIn: 'Log In',
        quickAccess: 'Quick Access',
        admin: 'Admin',
        teacher: 'Teacher',
        accounts: 'Accounts',
        loginError: 'Invalid credentials. Use "admin", "teacher" or "accountant" in email.',
        termsText: 'By logging in, you agree to our',
        terms: 'Terms',
        and: 'and',
        privacyPolicy: 'Privacy Policy',

        // Landing Page
        heroTagline: 'nerdOS v1.0 is here',
        heroTitle1: 'Institutional Intelligence.',
        heroTitle2: 'Unconditionally Fast.',
        heroDesc: 'The definitive operating system for modern education. Orchestrate every department, module, and user from a single, high-performance console.',
        getStarted: 'Get Started Now',
        signIn: 'Sign In',
        enquiry: 'Enquiry',
        solutions: 'Solutions',
        ecosystem: 'Ecosystem',
        apps: 'Apps',
        pricing: 'Pricing',

        // Common
        viewAll: 'View All',
        save: 'Save',
        cancel: 'Cancel',
        search: 'Search',
        filter: 'Filter',
        download: 'Download',
        add: 'Add',
        edit: 'Edit',
        delete: 'Delete',
        actions: 'Actions',
        status: 'Status',
        name: 'Name',
        date: 'Date',
        grade: 'Grade',
        class: 'Class',
        section: 'Section',
        subject: 'Subject',
        total: 'Total',
        active: 'Active',
        inactive: 'Inactive',
    },

    hi: {
        // Navigation / Sidebar
        dashboard: 'डैशबोर्ड',
        students: 'छात्र',
        teachers: 'शिक्षक',
        classes: 'कक्षाएं',
        timetable: 'समय सारणी',
        attendance: 'उपस्थिति',
        examinations: 'परीक्षाएं',
        fees: 'शुल्क',
        notices: 'सूचनाएं',
        transport: 'परिवहन',
        settings: 'सेटिंग्स',
        lms: 'एलएमएस',
        myClasses: 'मेरी कक्षाएं',
        assignments: 'असाइनमेंट',
        exams: 'परीक्षाएं',
        events: 'कार्यक्रम',
        leaveRequest: 'छुट्टी अनुरोध',
        logout: 'लॉग आउट',
        signOut: 'साइन आउट',
        feeCollection: 'शुल्क संग्रह',
        reports: 'रिपोर्ट',
        financeConsole: 'वित्त कंसोल',
        financeConsoleSub: 'संस्थागत वित्तीय अवलोकन और शुल्क ट्रैकिंग',
        teacherDashboard: 'शिक्षक डैशबोर्ड',
        teacherDashboardSub: 'वापस स्वागत है, डॉ. सारा जॉनसन',
        viewAll: 'सभी देखें',
        viewAllSubmissions: 'सभी सबमिशन देखें',
        recentStudentTask: 'हालिया छात्र कार्य',
        upcomingSchedule: 'आगामी कार्यक्रम',
        classPerformanceTrends: 'कक्षा प्रदर्शन रुझान',
        classAttendance: 'कक्षा उपस्थिति',
        recentCollections: 'हालिया संग्रह',
        totalLiquidity: 'कुल तरलता',
        collectionRate: 'संग्रह दर',
        initiateSettlement: 'निपटान शुरू करें',
        recentActivity: 'हालिया गतिविधि',
        quickActions: 'त्वरित क्रियाएं',
        financialAnalytics: 'वित्तीय विश्लेषण',
        systemHealth: 'सिस्टम स्वास्थ्य',
        present: 'उपस्थित',
        absent: 'अनुपस्थित',

        // Header
        adminDashboard: 'व्यवस्थापक डैशबोर्ड',
        adminDashboardSub: 'सिस्टम अवलोकन और स्कूल प्रदर्शन विश्लेषण',
        academicSession: 'शैक्षणिक सत्र 2025-26',
        language: 'भाषा',

        // Login
        welcomeBack: 'वापस स्वागत है',
        loginSubtitle: 'अपने NerdOS खाते में लॉग इन करें',
        email: 'ईमेल',
        password: 'पासवर्ड',
        forgotPassword: 'पासवर्ड भूल गए?',
        logIn: 'लॉग इन करें',
        quickAccess: 'त्वरित पहुंच',
        admin: 'प्रशासक',
        teacher: 'शिक्षक',
        accounts: 'लेखा',
        loginError: 'अमान्य क्रेडेंशियल। ईमेल में "admin", "teacher" या "accountant" उपयोग करें।',
        termsText: 'लॉग इन करके, आप हमारी सहमति देते हैं',
        terms: 'शर्तें',
        and: 'और',
        privacyPolicy: 'गोपनीयता नीति',

        // Landing Page
        heroTagline: 'nerdOS v1.0 आ गया है',
        heroTitle1: 'संस्थागत बुद्धिमत्ता।',
        heroTitle2: 'अद्वितीय तेज़।',
        heroDesc: 'आधुनिक शिक्षा के लिए निश्चित ऑपरेटिंग सिस्टम। एकल, उच्च-प्रदर्शन कंसोल से हर विभाग, मॉड्यूल और उपयोगकर्ता का संचालन करें।',
        getStarted: 'अभी शुरू करें',
        signIn: 'साइन इन',
        enquiry: 'पूछताछ',
        solutions: 'समाधान',
        ecosystem: 'पारिस्थितिकी तंत्र',
        apps: 'ऐप्स',
        pricing: 'मूल्य निर्धारण',

        // Common
        viewAll: 'सभी देखें',
        save: 'सहेजें',
        cancel: 'रद्द करें',
        search: 'खोजें',
        filter: 'फ़िल्टर',
        download: 'डाउनलोड',
        add: 'जोड़ें',
        edit: 'संपादित करें',
        delete: 'हटाएं',
        actions: 'क्रियाएं',
        status: 'स्थिति',
        name: 'नाम',
        date: 'तारीख',
        grade: 'ग्रेड',
        class: 'कक्षा',
        section: 'अनुभाग',
        subject: 'विषय',
        total: 'कुल',
        active: 'सक्रिय',
        inactive: 'निष्क्रिय',
    },

    mr: {
        // Navigation / Sidebar
        dashboard: 'डॅशबोर्ड',
        students: 'विद्यार्थी',
        teachers: 'शिक्षक',
        classes: 'वर्ग',
        timetable: 'वेळापत्रक',
        attendance: 'उपस्थिती',
        examinations: 'परीक्षा',
        fees: 'शुल्क',
        notices: 'सूचना',
        transport: 'वाहतूक',
        settings: 'सेटिंग्ज',
        lms: 'एलएमएस',
        myClasses: 'माझे वर्ग',
        assignments: 'असाइनमेंट',
        exams: 'परीक्षा',
        events: 'कार्यक्रम',
        leaveRequest: 'रजा विनंती',
        logout: 'लॉग आउट',
        signOut: 'साइन आउट',
        feeCollection: 'शुल्क संकलन',
        reports: 'अहवाल',
        financeConsole: 'वित्त कन्सोल',
        financeConsoleSub: 'संस्थात्मक आर्थिक आढावा आणि शुल्क ट्रॅकिंग',
        teacherDashboard: 'शिक्षक डॅशबोर्ड',
        teacherDashboardSub: 'पुन्हा स्वागत, डॉ. सारा जॉन्सन',
        viewAll: 'सर्व पहा',
        viewAllSubmissions: 'सर्व सबमिशन पहा',
        recentStudentTask: 'अलीकडील विद्यार्थी कार्य',
        upcomingSchedule: 'आगामी वेळापत्रक',
        classPerformanceTrends: 'वर्ग कामगिरी कल',
        classAttendance: 'वर्ग उपस्थिती',
        recentCollections: 'अलीकडील संकलन',
        totalLiquidity: 'एकूण तरलता',
        collectionRate: 'संकलन दर',
        initiateSettlement: 'सेटलमेंट सुरू करा',
        recentActivity: 'अलीकडील क्रियाकलाप',
        quickActions: 'जलद क्रिया',
        financialAnalytics: 'आर्थिक विश्लेषण',
        systemHealth: 'सिस्टम आरोग्य',
        present: 'उपस्थित',
        absent: 'अनुपस्थित',

        // Header
        adminDashboard: 'प्रशासक डॅशबोर्ड',
        adminDashboardSub: 'सिस्टम विहंगावलोकन आणि शाळा कामगिरी विश्लेषण',
        academicSession: 'शैक्षणिक सत्र 2025-26',
        language: 'भाषा',

        // Login
        welcomeBack: 'पुन्हा स्वागत आहे',
        loginSubtitle: 'आपल्या NerdOS खात्यात लॉग इन करा',
        email: 'ईमेल',
        password: 'पासवर्ड',
        forgotPassword: 'पासवर्ड विसरलात?',
        logIn: 'लॉग इन करा',
        quickAccess: 'जलद प्रवेश',
        admin: 'प्रशासक',
        teacher: 'शिक्षक',
        accounts: 'लेखा',
        loginError: 'अवैध क्रेडेन्शिअल. ईमेलमध्ये "admin", "teacher" किंवा "accountant" वापरा.',
        termsText: 'लॉग इन करून, आपण आमच्याशी सहमत आहात',
        terms: 'अटी',
        and: 'आणि',
        privacyPolicy: 'गोपनीयता धोरण',

        // Landing Page
        heroTagline: 'nerdOS v1.0 आले आहे',
        heroTitle1: 'संस्थात्मक बुद्धिमत्ता.',
        heroTitle2: 'अतुलनीय वेगवान.',
        heroDesc: 'आधुनिक शिक्षणासाठी निश्चित ऑपरेटिंग सिस्टम. एकाच उच्च-कार्यक्षमता कन्सोलवरून प्रत्येक विभाग, मॉड्यूल आणि वापरकर्त्याचे व्यवस्थापन करा.',
        getStarted: 'आता सुरू करा',
        signIn: 'साइन इन',
        enquiry: 'चौकशी',
        solutions: 'उपाय',
        ecosystem: 'परिसंस्था',
        apps: 'अ‍ॅप्स',
        pricing: 'मूल्य निर्धारण',

        // Common
        viewAll: 'सर्व पहा',
        save: 'जतन करा',
        cancel: 'रद्द करा',
        search: 'शोधा',
        filter: 'फिल्टर',
        download: 'डाउनलोड',
        add: 'जोडा',
        edit: 'संपादित करा',
        delete: 'हटवा',
        actions: 'क्रिया',
        status: 'स्थिती',
        name: 'नाव',
        date: 'तारीख',
        grade: 'ग्रेड',
        class: 'वर्ग',
        section: 'विभाग',
        subject: 'विषय',
        total: 'एकूण',
        active: 'सक्रिय',
        inactive: 'निष्क्रिय',
    },

    ar: {
        // Navigation / Sidebar
        dashboard: 'لوحة التحكم',
        students: 'الطلاب',
        teachers: 'المعلمون',
        classes: 'الفصول',
        timetable: 'الجدول الزمني',
        attendance: 'الحضور',
        examinations: 'الامتحانات',
        fees: 'الرسوم',
        notices: 'الإشعارات',
        transport: 'النقل',
        settings: 'الإعدادات',
        lms: 'نظام التعلم',
        myClasses: 'فصولي',
        assignments: 'الواجبات',
        exams: 'الامتحانات',
        events: 'الفعاليات',
        leaveRequest: 'طلب إجازة',
        logout: 'تسجيل الخروج',
        signOut: 'تسجيل الخروج',
        feeCollection: 'تحصيل الرسوم',
        reports: 'التقارير',
        financeConsole: 'وحدة التحكم المالية',
        financeConsoleSub: 'نظرة عامة مالية مؤسسية في الوقت الفعلي وتتبع الرسوم',
        teacherDashboard: 'لوحة تحكم المعلم',
        teacherDashboardSub: 'مرحبًا بعودتك، د. سارة جونسون',
        viewAll: 'عرض الكل',
        viewAllSubmissions: 'عرض كل التسليمات',
        recentStudentTask: 'مهام الطلاب الأخيرة',
        upcomingSchedule: 'الجدول القادم',
        classPerformanceTrends: 'اتجاهات أداء الفصل',
        classAttendance: 'حضور الفصل',
        recentCollections: 'التحصيلات الأخيرة',
        totalLiquidity: 'إجمالي السيولة',
        collectionRate: 'معدل التحصيل',
        initiateSettlement: 'بدء التسوية',
        recentActivity: 'النشاط الأخير',
        quickActions: 'إجراءات سريعة',
        financialAnalytics: 'التحليلات المالية',
        systemHealth: 'صحة النظام',
        present: 'حاضر',
        absent: 'غائب',

        // Header
        adminDashboard: 'لوحة تحكم المشرف',
        adminDashboardSub: 'نظرة عامة على النظام وتحليلات أداء المدرسة',
        academicSession: 'العام الدراسي 2025-26',
        language: 'اللغة',

        // Login
        welcomeBack: 'مرحبًا بعودتك',
        loginSubtitle: 'تسجيل الدخول إلى حساب NerdOS الخاص بك',
        email: 'البريد الإلكتروني',
        password: 'كلمة المرور',
        forgotPassword: 'نسيت كلمة المرور؟',
        logIn: 'تسجيل الدخول',
        quickAccess: 'وصول سريع',
        admin: 'المشرف',
        teacher: 'المعلم',
        accounts: 'المحاسبة',
        loginError: 'بيانات اعتماد غير صالحة. استخدم "admin" أو "teacher" أو "accountant" في البريد الإلكتروني.',
        termsText: 'بتسجيل الدخول، فأنت توافق على',
        terms: 'الشروط',
        and: 'و',
        privacyPolicy: 'سياسة الخصوصية',

        // Landing Page
        heroTagline: 'nerdOS v1.0 متاح الآن',
        heroTitle1: 'ذكاء مؤسسي.',
        heroTitle2: 'سرعة لا مثيل لها.',
        heroDesc: 'نظام التشغيل المحدد للتعليم الحديث. أدر كل قسم ووحدة ومستخدم من وحدة تحكم واحدة عالية الأداء.',
        getStarted: 'ابدأ الآن',
        signIn: 'تسجيل الدخول',
        enquiry: 'استفسار',
        solutions: 'الحلول',
        ecosystem: 'النظام البيئي',
        apps: 'التطبيقات',
        pricing: 'التسعير',

        // Common
        viewAll: 'عرض الكل',
        save: 'حفظ',
        cancel: 'إلغاء',
        search: 'بحث',
        filter: 'تصفية',
        download: 'تنزيل',
        add: 'إضافة',
        edit: 'تعديل',
        delete: 'حذف',
        actions: 'إجراءات',
        status: 'الحالة',
        name: 'الاسم',
        date: 'التاريخ',
        grade: 'الدرجة',
        class: 'الفصل',
        section: 'القسم',
        subject: 'المادة',
        total: 'المجموع',
        active: 'نشط',
        inactive: 'غير نشط',
    }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
    const [language, setLanguage] = useState(() => {
        return localStorage.getItem('schoolos-language') || 'en';
    });

    const changeLanguage = (code) => {
        setLanguage(code);
        localStorage.setItem('schoolos-language', code);
        const lang = languages.find(l => l.code === code);
        document.documentElement.dir = lang?.dir || 'ltr';
        document.documentElement.lang = code;
    };

    const t = (key) => {
        return translations[language]?.[key] || translations['en']?.[key] || key;
    };

    const currentLanguage = languages.find(l => l.code === language) || languages[0];

    return (
        <LanguageContext.Provider value={{ language, changeLanguage, t, currentLanguage, languages }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
}
